import {Modal} from 'antd';
import {useEffect} from 'react';

import {Locale} from '../../../provider/locale/locale';
import {useModal} from '../../../provider/modal/modal-hook';
import {useCreateEvent} from '../../../service/events/events-hook';
import {CommonEventStatusEnum, EventFormType} from '../../../service/events/events-type';
import {postCompanySelectorCompanySchema} from '../../../service/feature-companies/feature-companies-api-type';
import {CompaniesSelectorFeatureEnum} from '../../../service/feature-companies/feature-companies-const';
import {useCompaniesSelector} from '../../../service/feature-companies/feature-companies-hook';
import {PostSelectorCompanyType} from '../../../service/feature-companies/feature-companies-type';

import {EventForm} from './event-form';
import {EVENT_FORM_MODAL_WIDTH, prepareEventRequestData} from './event-form-helper';

type PropsType = {
    setIsOpen: (isOpen: boolean) => void;
    onCreateSuccess?: VoidFunction;
};

export function CreateEventFormModal({setIsOpen, onCreateSuccess}: PropsType): JSX.Element {
    const companiesSelector = useCompaniesSelector<PostSelectorCompanyType>({
        feature: CompaniesSelectorFeatureEnum.Posts,
        companySchema: postCompanySelectorCompanySchema,
        resourceId: null,
    });

    const {modal} = useModal();
    const {mutateAsync: createEvent} = useCreateEvent();
    const {initializeSelector, selectorId} = companiesSelector;

    useEffect(() => {
        initializeSelector();
    }, [initializeSelector]);

    async function handleSubmit(values: EventFormType, status: CommonEventStatusEnum): Promise<void> {
        await createEvent(prepareEventRequestData(values, selectorId, status));
        onCreateSuccess?.();
    }

    function handleCancel(): void {
        modal.confirm({
            maskClosable: true,
            title: <Locale stringKey="EVENTS__CREATE__CONFIRM_CLOSE__TITLE" />,
            content: <Locale stringKey="EVENTS__CONFIRM_CLOSE__CONTENT" />,
            okText: <Locale stringKey="EVENTS__CREATE__CONFIRM_CLOSE__CONFIRM" />,
            cancelText: <Locale stringKey="POPUP__BUTTON__CANCEL" />,
            okButtonProps: {danger: true, type: 'primary'},
            onOk: () => setIsOpen(false),
        });
    }

    return (
        <Modal
            centered
            destroyOnClose
            footer={null}
            onCancel={handleCancel}
            open
            title={<Locale stringKey="EVENTS__CREATE__TITLE" />}
            width={EVENT_FORM_MODAL_WIDTH}
        >
            <EventForm
                closeModal={() => setIsOpen(false)}
                companiesSelector={companiesSelector}
                mode="create"
                onCancel={handleCancel}
                onSubmit={handleSubmit}
            />
        </Modal>
    );
}
